import React from "react";

// Package Import
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  styled,
  Paper,
  Card,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  GlobeBlueIcon,
  InventoryIcon,
  HashIcon,
  TempratureIcon,
  BatchIcon1,
  UnitsRequested,
} from "../../../../Svg";
import { textAlign } from "@mui/system";
// User Import

// Constant
const Input = styled("input")({
  display: "none",
});
// Component

const Details = () => {
  // Hooks

  const theme = useTheme();

  // Constant

  const navigate = useNavigate();
  // Render
  return (
    <Box padding={{ xs: 0, sm: 1, md: 2, lg: 2, xl: 2 }}>
      <Grid container spacing={2}>
        <Grid item spacing={2} xs={12} sm={12} md={6} lg={6} xl={6}>
          {/* <Grid container padding={2}> */}
          <Paper>
            <Box padding={1}>
              <Typography variant="h6" component="div">
                Request Details
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                updated 1 hour ago
              </Typography>
              {/* 1 ROW */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box
                  height={60}
                  width={60}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <UnitsRequested />
                </Box>
                <Typography sx={{ paddingTop: 1.8, textAlign: "left" }}>
                  Units Requested
                </Typography>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip label="10,000 units " />
                </Box>
              </Grid>
              {/* 2nd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box
                  height={60}
                  width={60}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <BatchIcon1 />
                </Box>
                <Typography sx={{ paddingTop: 1.8 }}>Requested Date</Typography>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip label="25-12-2021" />
                </Box>
              </Grid>
              {/* 3rd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box
                  height={60}
                  width={60}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <GlobeBlueIcon />
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    component="div"
                    sx={{ paddingTop: 1 }}
                  >
                    Requested By
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip label="Sydney, Australia" />
                </Box>
              </Grid>
              {/* 4th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box
                  height={60}
                  width={60}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <InventoryIcon />
                </Box>{" "}
                <Box>
                  <Typography
                    variant="body1"
                    component="div"
                    sx={{ paddingTop: 1 }}
                  >
                    Current Inventory
                  </Typography>
                  <Typography color="text.secondary" sx={{ fontSize: "12px" }}>
                    updated 30 min ago
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip label="1000 units " />
                </Box>
              </Grid>
              <Box display={"flex"} justifyContent={"center"}>
                <Button
                  variant="contained"
                  size="large"
                  sx={{
                    bgcolor: "#435CFF",
                    borderRadius: 2,
                    mr: 1,
                  }}
                >
                  Accept
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  sx={{
                    bgcolor: "#435CFF",
                    borderRadius: 2,
                    //   bgcolor: "success",
                  }}
                >
                  Reject
                </Button>
              </Box>
            </Box>
          </Paper>
          {/* </Grid> */}
          <Grid container>
            <Card></Card>
          </Grid>
        </Grid>
        {/* second grid ----------------------------------------------------------- */}

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          {/* <Grid container padding={2}> */}
          <Paper sx={{ height: 415, width: "100%" }}>
            <Box
              padding={1}
              // sx={{
              //   height: "75%",
              // }}
            >
              <Typography variant="h6" component="div">
                Inventory Status
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                updated 1 hour ago
              </Typography>
              {/* 1 ROW */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box
                  height={"60px"}
                  width={"60px"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <HashIcon />
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    component="div"
                    sx={{ paddingTop: 1 }}
                  >
                    Vaccine Batch
                  </Typography>

                  <Typography color="text.secondary" sx={{ fontSize: "12px" }}>
                    Current Batch
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip label="256487" />
                </Box>
              </Grid>
              {/* 2nd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box
                  height={"60px"}
                  width={"60px"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <TempratureIcon />
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    component="div"
                    sx={{ paddingTop: 1 }}
                  >
                    Storage Temperature
                  </Typography>

                  <Typography color="text.secondary" sx={{ fontSize: "12px" }}>
                    Updated 30 Minutes ago
                  </Typography>
                </Box>

                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip label="7  Degree" />
                </Box>
              </Grid>
              {/* 3rd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box
                  height={"60px"}
                  width={"60px"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <BatchIcon1 />
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    component="div"
                    sx={{ paddingTop: 1 }}
                  >
                    Batch Recieved
                  </Typography>

                  <Typography color="text.secondary" sx={{ fontSize: "12px" }}>
                    Current Batch
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip label="1-12-2021" />
                </Box>
              </Grid>
              {/* 4th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box
                  height={"60px"}
                  width={"60px"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <BatchIcon1 />
                </Box>{" "}
                <Box>
                  <Typography
                    variant="body1"
                    component="div"
                    sx={{ paddingTop: 1 }}
                  >
                    Batch Expiry
                  </Typography>
                  <Typography color="text.secondary" sx={{ fontSize: "12px" }}>
                    Current Batch
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip label="3-2-2022" />
                </Box>
              </Grid>
            </Box>
          </Paper>
          {/* </Grid> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Details;
